import styled from "styled-components";

export const MediumLabelBox = styled.div`
    color: ${props => props.theme.colors.medium};
  
`
